var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginPageLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405,
    height: 172.923,
    viewBox: "0 0 405 172.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.24 107.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.24 -107.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163352",
    "data-name": "Group 163352",
    transform: "translate(152.56 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24773",
    "data-name": "Path 24773",
    d: "M356.15,33.541a2.749,2.749,0,0,1,2.377,1.2l-1.074.515a1.617,1.617,0,0,0-.587-.558,1.833,1.833,0,0,0-1.647.115.73.73,0,0,0-.372.63c0,.344.315.63.959.845l.888.3a3.7,3.7,0,0,1,1.561.859,1.747,1.747,0,0,1,.5,1.246,2.019,2.019,0,0,1-.816,1.647,3.537,3.537,0,0,1-3.923.1,2.434,2.434,0,0,1-.916-1.561l1.346-.243a1.69,1.69,0,0,0,.315.873,1.532,1.532,0,0,0,1.2.458,1.618,1.618,0,0,0,1.031-.329,1.088,1.088,0,0,0,.344-1.246.932.932,0,0,0-.215-.329,2.424,2.424,0,0,0-.4-.272,4.581,4.581,0,0,0-.573-.243l-.845-.286c-1.2-.415-1.818-1.017-1.818-1.819a1.632,1.632,0,0,1,.773-1.36,3.179,3.179,0,0,1,1.89-.544",
    transform: "translate(-297.557 13.741)",
    fill: "#00b258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24774",
    "data-name": "Path 24774",
    d: "M362.43,34.642h-3.079v1.733h2.964v1.017h-2.964v3.422H358.02V33.64h4.41Z",
    transform: "translate(-295.432 13.784)",
    fill: "#00b258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24775",
    "data-name": "Path 24775",
    d: "M363.632,39.794h.6a6.244,6.244,0,0,0,1.432-.158,2.864,2.864,0,0,0,1.06-.515,2.262,2.262,0,0,0,.988-1.9,2.32,2.32,0,0,0-.974-1.919,4.3,4.3,0,0,0-2.563-.659h-.6ZM362.3,40.81V33.651h1.847a8.175,8.175,0,0,1,2.1.215,4.066,4.066,0,0,1,1.432.7,3.236,3.236,0,0,1,0,5.341,4.3,4.3,0,0,1-1.432.716,8.476,8.476,0,0,1-2.076.2Z",
    transform: "translate(-293.583 13.788)",
    fill: "#00b258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24776",
    "data-name": "Path 24776",
    d: "M372.536,38.188l-1.317-2.434-1.432,2.434Zm.544,1.017H369.3l-.988,1.747H366.88l4.367-7.632,4.21,7.632h-1.432Z",
    transform: "translate(-291.605 13.646)",
    fill: "#00b258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24777",
    "data-name": "Path 24777",
    d: "M366.474,10.827c-16.581-10.868-48.14,25.115-48.14,25.115V37.26l9.751-9.451c19.087-16.682,28.037-7.159,28.037-7.159C369.9,35.527,314.31,71.511,314.31,71.511l.2.5c12.057-4.725,36.986-25.33,36.986-25.33,28.638-26.232,14.978-35.8,14.978-35.8",
    transform: "translate(-314.31 3.048)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24778",
    "data-name": "Path 24778",
    d: "M402.739,14.761v-.515a305,305,0,0,0-35.683,14.978s-1.3-10.353,17.283-15.751l-.1-1S358.608,18,357.906,34.979c0,0-27.535,20.4-17.684,33.377,0,0,7.933,9.937,30.958-3.322,0,0,15.479-9.451,20.906-13.975l-.1-1.1s-29.683,24.7-40.007,9.823S396.5,16.465,402.739,14.761",
    transform: "translate(-304.038 4.641)",
    fill: "#00b258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24779",
    "data-name": "Path 24779",
    d: "M360.159.52a7.159,7.159,0,1,0,7.159,7.159A7.159,7.159,0,0,0,360.159.52",
    transform: "translate(-297.6 -0.52)",
    fill: "#f15a31"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24780",
    "data-name": "Path 24780",
    d: "M.716,20.084C.344,19.7.043,19.368.043,17.893a5.5,5.5,0,0,1,5.5-5.083,9.809,9.809,0,0,1,3.05.788l-.673,1.432a4.954,4.954,0,0,0-2.377-.63c-1.847-.043-3.966,1.546-3.966,2.978,0,1.088,0,1.575.5,2.033.558.759,1.69.644,3.351.644H9.05l-.873,1.618H0V20.084Z",
    transform: "translate(0.24 104.08)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    "data-name": "Rectangle 3212",
    width: 3.394,
    height: 26.834,
    transform: "translate(12.497 99.266)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24781",
    "data-name": "Path 24781",
    d: "M36.447,20.073c0,10.925-4.453,12.057-12.286,12.214H20.4s-.916-1.274-2.191-3.394c6.1,0,11.527.573,13.116-1.761.716-1.06,1.733-2.649,1.733-6.716,0-6.329-2.406-11.727-8.062-11.613-3.78,0-8.147,1.733-8.147,8.82,0,3.093,1.618,3.852,4.41,3.852h9.121l-2.334,3.394h-5.1c-7,0-9.493-.83-9.493-7.245A11.928,11.928,0,0,1,24.992,5.41c8.362,0,11.455,7.918,11.455,14.706",
    transform: "translate(6.048 100.712)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24782",
    "data-name": "Path 24782",
    d: "M33.353,24.817,31.62,21.38H44.65c3.58,0,5.728.258,7.016-1.432.831-1.06,1.131-2.033,1.131-4.525,0-3.164-4.3-6.558-8.362-6.558-5.728,0-7.245,3.394-8.82,7.689H32.021s.5-1.8.873-2.864A11.555,11.555,0,0,1,44.435,5.543c6.773,0,11.985,5.885,11.985,11.083a11.784,11.784,0,0,1-1.174,4.754h3.737v3.437Z",
    transform: "translate(13.896 101.158)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24783",
    "data-name": "Path 24783",
    d: "M54.789,23.674V.22h3.394V27.054H49.52V23.674Z",
    transform: "translate(21.627 99.046)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 3.394,
    height: 26.834,
    transform: "translate(84.407 99.266)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24784",
    "data-name": "Path 24784",
    d: "M86.677,20.073c0,10.925-4.453,12.057-12.3,12.214H70.612s-.9-1.274-2.176-3.394c6.1,0,11.455.573,13.116-1.761.716-1.06,1.733-2.649,1.733-6.716,0-6.329-2.42-11.727-8.076-11.613-3.766,0-8.133,1.733-8.133,8.82,0,3.093,1.618,3.852,4.41,3.852h9.121l-2.334,3.394h-5.1c-7,0-9.493-.83-9.493-7.245A11.913,11.913,0,0,1,75.208,5.41c8.377,0,11.455,7.918,11.455,14.706",
    transform: "translate(19.664 100.712)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24785",
    "data-name": "Path 24785",
    d: "M89.8,20.084c-.372-.387-.673-.716-.673-2.191a5.513,5.513,0,0,1,5.57-5.083,10.023,10.023,0,0,1,3.064.788L97.07,15.03a4.954,4.954,0,0,0-2.377-.673c-1.847,0-3.952,1.575-3.952,3.05,0,1.088,0,1.575.487,2.033.573.759,1.69.644,3.351.644H98.13l-.873,1.589H89.08V20.084Z",
    transform: "translate(27.786 104.08)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3214",
    "data-name": "Rectangle 3214",
    width: 3.394,
    height: 26.834,
    transform: "translate(128.229 99.266)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24786",
    "data-name": "Path 24786",
    d: "M116.25,2.761A2.291,2.291,0,0,1,114.3,5.41a2.348,2.348,0,0,1-.63-4.654,2.291,2.291,0,0,1,2.577,2M103.907,26.888l-1.747-3.394H115.2c3.58,0,5.728.258,7.016-1.432.83-1.06,1.131-2.033,1.131-4.525,0-3.164-4.3-6.558-8.362-6.558-5.728,0-7.245,3.394-8.82,7.689h-3.58s.487-1.8.859-2.864A11.555,11.555,0,0,1,114.99,7.658c6.773,0,11.985,5.885,11.985,11.083a11.785,11.785,0,0,1-1.174,4.754h3.737v3.394Z",
    transform: "translate(31.28 99.248)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24787",
    "data-name": "Path 24787",
    d: "M135.334,2.441a2.305,2.305,0,1,1-.883-1.549,2.32,2.32,0,0,1,.883,1.549m9.651,15.264c0-3.164-4.038-6.558-9.809-6.558-4.067,0-9.723,3.394-9.723,6.558,0,2.491,0,3.465.9,4.525,1.289,1.618,5.212,1.432,8.792,1.432s7.646.258,8.935-1.432c.816-1.06.9-2.033.9-4.525M120.07,23.59h3.422c-.831-.8-1.432-1.518-1.432-4.754a10.281,10.281,0,0,1,3.737-7.689h-3.508l3.05-3.394h11.04c6.787,0,12,5.885,12,11.083,0,3.236-.616,3.952-1.432,4.754h3.422v3.437h-30.3Z",
    transform: "translate(36.616 99.12)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24788",
    "data-name": "Path 24788",
    d: "M145.659,23.649V.28h3.394V23.649h4.3v3.422l-12.959-.043V23.649Z",
    transform: "translate(43.507 99.068)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24789",
    "data-name": "Path 24789",
    d: "M153.884,23.674V.22h3.394V27.054H148.6V23.674Z",
    transform: "translate(46.22 99.046)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24790",
    "data-name": "Path 24790",
    d: "M180.442,2.026a1.805,1.805,0,1,1,0-.014m-4.983,0A2.291,2.291,0,0,1,173.5,4.6a2.32,2.32,0,1,1,1.919-2.577m-8.033,15.865c0,2.491-.215,3.537.616,4.6,1.274,1.618,4.181,1.289,7.761,1.289h7.718c2.864,0,1.289-5.513,1.289-5.513-1.589-4.3-3.122-6.93-8.778-6.93-4.081,0-8.591,3.394-8.591,6.558M188.3,7.939V23.776h2.721v3.437H169.359a7.732,7.732,0,0,1-4.3-3.021c-.9-1.661-.974-1.89-.974-5.126,0-5.2,5.2-11.083,11.985-11.083a12.257,12.257,0,0,1,8.735,3.58V7.982Z",
    transform: "translate(50.132 98.95)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24791",
    "data-name": "Path 24791",
    d: "M197.772,12.376a8.906,8.906,0,0,1,2.076,8.262,5.241,5.241,0,0,1-1.174,2.377c-1.16,1.618-2.864,3.422-4.625,2.406-2.764-1.618-5.813-3.322-5.813-3.322l.5-3.766c.215,0,4.553,3.164,6.028,3.465,0,0,1.876-.1,1.876-3.58a4.525,4.525,0,0,0-4.9-4.711c-2.935,0-3.766,1.432-4.3,3.809-.487,2.119-.143,3.995-2.262,5.055a4.711,4.711,0,0,1-2.291.344h-.945V19.321h.945c.644,0,1.317,0,1.317-.53,0-3.551,1.432-8.491,8.176-8.491a7.775,7.775,0,0,1,5.384,2.076",
    transform: "translate(56.045 102.919)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24792",
    "data-name": "Path 24792",
    d: "M205.283,27.054H196.62V.22h3.394V23.674h5.269Z",
    transform: "translate(61.086 99.046)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24793",
    "data-name": "Path 24793",
    d: "M226.585,15.492c0-3.164-4.024-6.558-9.794-6.558-4.067,0-9.723,3.394-9.723,6.558,0,2.491.072,3.465.9,4.525,1.274,1.618,5.2,1.432,8.778,1.432s7.661.258,8.935-1.432c.831-1.06.9-2.033.9-4.525M201.67,21.377h3.437c-.831-.8-1.432-1.518-1.432-4.754A10.324,10.324,0,0,1,207.4,8.934H203.9l3.05-3.394h11.04c6.787,0,11.985,5.885,11.985,11.083,0,3.236-.6,3.952-1.432,4.754h3.437v3.437H201.67Z",
    transform: "translate(61.351 101.161)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24794",
    "data-name": "Path 24794",
    d: "M227.274,23.674V.22h3.394V27.054H221.99V23.674Z",
    transform: "translate(68.939 99.046)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3215",
    "data-name": "Rectangle 3215",
    width: 3.394,
    height: 26.834,
    transform: "translate(303.41 99.266)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24795",
    "data-name": "Path 24795",
    d: "M258.782,2.047A2.32,2.32,0,1,1,257.39.125a2.32,2.32,0,0,1,1.392,1.922m-4.983,0a2.291,2.291,0,0,1-1.962,2.592A2.336,2.336,0,1,1,253.8,2.033M245.781,17.9c0,2.492-.229,3.537.6,4.6,1.274,1.618,4.181,1.289,7.761,1.289h7.718c2.864,0,1.274-5.513,1.274-5.513-1.575-4.3-3.122-6.93-8.778-6.93-4.067,0-8.591,3.394-8.591,6.558M266.6,7.946V23.8h2.721v3.437H247.7a7.732,7.732,0,0,1-4.3-3.021c-.9-1.661-.974-1.89-.974-5.126,0-5.2,5.2-11.083,11.985-11.083a12.329,12.329,0,0,1,8.706,3.48V7.9Z",
    transform: "translate(73.964 98.93)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24796",
    "data-name": "Path 24796",
    d: "M264.553,7.861c-.258-.272-.487-.53-.487-1.589a3.981,3.981,0,0,1,3.952-3.651,7.474,7.474,0,0,1,2.234.558l-.5,1.017a3.565,3.565,0,0,0-1.733-.487c-1.317,0-2.864,1.174-2.864,2.219,0,.759,0,1.131.344,1.432.415.558,1.231.487,2.406.487h2.606l-.616,1.045h-5.885V7.861ZM265.6,22.638V12.085h3.379V22.638h4.3v3.437H260.3V22.638Z",
    transform: "translate(75.64 99.997)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24797",
    "data-name": "Path 24797",
    d: "M279.21,27.286a2.291,2.291,0,0,1-1.962,2.592,2.32,2.32,0,1,1,1.962-2.592m-4.969,0a2.305,2.305,0,1,1-.883-1.549,2.32,2.32,0,0,1,.883,1.549m-.8-7.5V9.23h3.394V19.783h4.3V23.22H268.17V19.783Z",
    transform: "translate(79.039 102.29)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24798",
    "data-name": "Path 24798",
    d: "M300.989,16.343c0-2.978-4.8-6.515-8.591-6.515v12.4c3.766,0,6.486.115,7.646-1.432.83-1.06.916-2.033.916-4.525M289,9.971c-3.88,0-7.575,3.666-7.575,6.3s.115,3.437.9,4.525C283.42,22.228,289,22.228,289,22.228Zm0-4.854L292.4,3.57V6.391c6.744,0,11.956,5.885,11.956,11.083,0,3.236-.616,3.952-1.432,4.754h3.422v3.437H276.06V22.228H279.5c-.83-.8-1.432-1.518-1.432-4.754,0-4.453,4.067-9.579,10.968-10.825Z",
    transform: "translate(82.446 100.375)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24799",
    "data-name": "Path 24799",
    d: "M301.564,23.674V.22h3.394V27.054H296.28V23.674Z",
    transform: "translate(91.179 99.046)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3216",
    "data-name": "Rectangle 3216",
    width: 3.394,
    height: 26.834,
    transform: "translate(400.733 99.266)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24800",
    "data-name": "Path 24800",
    d: "M14.442,36.853l-2.721,1.618a4.911,4.911,0,0,0-1.432-1.733,3.48,3.48,0,0,0-1.861-.458,3.451,3.451,0,0,0-2.334.8,2.449,2.449,0,0,0-.916,1.962c0,1.088.8,1.962,2.42,2.62l2.219.916A9.465,9.465,0,0,1,13.8,45.259a6.086,6.086,0,0,1,1.246,3.88A6.83,6.83,0,0,1,13,54.222a7.159,7.159,0,0,1-5.141,2.019,6.773,6.773,0,0,1-4.783-1.733A8.033,8.033,0,0,1,.71,49.655l3.408-.745a5.728,5.728,0,0,0,.816,2.663A3.48,3.48,0,0,0,7.97,53.005a3.494,3.494,0,0,0,2.606-1.045,3.694,3.694,0,0,0,1.045-2.678,3.9,3.9,0,0,0-.186-1.188,2.864,2.864,0,0,0-.558-.988,4.954,4.954,0,0,0-.988-.859,11.211,11.211,0,0,0-1.432-.759L6.28,44.657Q1.712,42.724,1.712,38.93a5.355,5.355,0,0,1,1.933-4.2A6.959,6.959,0,0,1,8.428,33.1a6.687,6.687,0,0,1,6.014,3.752",
    transform: "translate(0.547 109.328)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24801",
    "data-name": "Path 24801",
    d: "M16.775,46.229a4.825,4.825,0,0,0,1.088,3.279A3.508,3.508,0,0,0,20.655,50.8a3.78,3.78,0,0,0,2.864-1.231,5.327,5.327,0,0,0,0-6.529,3.709,3.709,0,0,0-2.864-1.26,3.58,3.58,0,0,0-2.792,1.274,4.682,4.682,0,0,0-1.088,3.179m7.732-6.959h3.25V53.388h-3.25V51.957a6.272,6.272,0,0,1-9.164-.229,7.832,7.832,0,0,1-1.89-5.5,7.575,7.575,0,0,1,1.89-5.269,6.085,6.085,0,0,1,4.74-2.119,6,6,0,0,1,4.425,2.048Z",
    transform: "translate(6.046 111.809)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24802",
    "data-name": "Path 24802",
    d: "M31.211,39.17v8.047c0,2.32.916,3.48,2.764,3.48s2.778-1.16,2.778-3.48V39.17H40V47.3a9.236,9.236,0,0,1-.415,2.864,4.983,4.983,0,0,1-1.432,1.976,6.171,6.171,0,0,1-4.21,1.432,6.128,6.128,0,0,1-4.181-1.432,4.926,4.926,0,0,1-1.432-1.976,7.9,7.9,0,0,1-.4-2.864V39.17Z",
    transform: "translate(12.3 111.951)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24803",
    "data-name": "Path 24803",
    d: "M43.3,49.222A4.883,4.883,0,0,0,44.37,52.5a3.551,3.551,0,0,0,2.864,1.289A3.723,3.723,0,0,0,50.1,52.558a5.327,5.327,0,0,0,0-6.529,3.823,3.823,0,0,0-5.728,0A4.74,4.74,0,0,0,43.3,49.222M51.014,31.91h3.308V56.381H51.014V54.949a6.086,6.086,0,0,1-4.3,1.876,6.186,6.186,0,0,1-4.8-2.1A7.775,7.775,0,0,1,40,49.222a7.5,7.5,0,0,1,1.9-5.255,6.057,6.057,0,0,1,9.15-.1Z",
    transform: "translate(17.513 108.816)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24804",
    "data-name": "Path 24804",
    d: "M57.6,55.638h-3.25V41.563H57.6Zm-3.737-19.9a2.1,2.1,0,0,1,4.21,0,2.048,2.048,0,0,1-.616,1.432,1.962,1.962,0,0,1-1.432.616A2.1,2.1,0,0,1,53.9,35.649",
    transform: "translate(23.502 109.559)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24805",
    "data-name": "Path 24805",
    d: "M79.867,36.589H72.092v5.327h7.489v3.179H72.092V55.7H68.77V33.41h11.1Z",
    transform: "translate(21.461 109.464)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24806",
    "data-name": "Path 24806",
    d: "M83.28,46.214a4.74,4.74,0,0,0,1.131,3.336,4.382,4.382,0,0,0,6.086,0,5.241,5.241,0,0,0,0-6.544,3.966,3.966,0,0,0-3.05-1.246,3.923,3.923,0,0,0-3.007,1.246,4.51,4.51,0,0,0-1.16,3.207m-3.279,0a6.945,6.945,0,0,1,2.176-5.183,7.675,7.675,0,0,1,10.668,0,7.413,7.413,0,0,1-5.4,12.7,7.159,7.159,0,0,1-5.3-2.162A7.331,7.331,0,0,1,80,46.214",
    transform: "translate(24.838 111.824)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24807",
    "data-name": "Path 24807",
    d: "M96.943,46.214a4.74,4.74,0,0,0,1.131,3.336,4.382,4.382,0,0,0,6.086,0,5.241,5.241,0,0,0,0-6.544,3.966,3.966,0,0,0-3.05-1.246A3.923,3.923,0,0,0,98.1,43.006a4.51,4.51,0,0,0-1.16,3.207m-3.322,0A7,7,0,0,1,95.8,41.03a7.675,7.675,0,0,1,10.668,0,7.413,7.413,0,0,1-5.4,12.7,7.159,7.159,0,0,1-5.3-2.162,7.331,7.331,0,0,1-2.148-5.355",
    transform: "translate(29.03 111.824)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24808",
    "data-name": "Path 24808",
    d: "M111,49.222a4.883,4.883,0,0,0,1.074,3.279,3.551,3.551,0,0,0,2.864,1.289,3.78,3.78,0,0,0,2.864-1.231,5.384,5.384,0,0,0,0-6.529,3.709,3.709,0,0,0-2.864-1.26,3.623,3.623,0,0,0-2.864,1.274A4.668,4.668,0,0,0,111,49.222m7.718-17.312h3.25V56.381h-3.236V54.949a6.086,6.086,0,0,1-4.3,1.876,6.186,6.186,0,0,1-4.868-2.176,7.775,7.775,0,0,1-1.89-5.427,7.5,7.5,0,0,1,1.89-5.2,6.057,6.057,0,0,1,9.15-.1Z",
    transform: "translate(33.378 108.816)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24809",
    "data-name": "Path 24809",
    d: "M136.48,41l.286-.2c.473-.358.859-.673,1.16-.931a4.583,4.583,0,0,0,.659-.673,1.976,1.976,0,0,0,.444-1.317,1.862,1.862,0,0,0-.6-1.432,2.234,2.234,0,0,0-1.575-.544,2.191,2.191,0,0,0-1.532.558,1.733,1.733,0,0,0-.616,1.432,3.036,3.036,0,0,0,.773,1.933l.831,1.017.172.215m-.7,4.3-.186.129a16.194,16.194,0,0,0-2.864,2.305,2.864,2.864,0,0,0-.73,1.833,3.823,3.823,0,0,0,3.651,3.651c1.3,0,2.792-.859,4.5-2.549Zm2.663-1.9,4.024,4.854.129-.143c.43-.473.845-.931,1.231-1.432s.759-.9,1.1-1.432l2.205,2.248c-.272.387-.63.83-1.074,1.346s-.959,1.088-1.561,1.761l4.138,5.169h-4.2l-2.219-2.735a8.906,8.906,0,0,1-6.386,3.179,7.159,7.159,0,0,1-5.026-1.876,6.243,6.243,0,0,1-2.019-4.711,6.544,6.544,0,0,1,3.164-5.6l1.432-.988h.086l.215-.172a6.873,6.873,0,0,1-2.219-4.639,4.883,4.883,0,0,1,1.432-3.666,5.971,5.971,0,0,1,7.675,0,4.5,4.5,0,0,1,1.432,3.465,4.424,4.424,0,0,1-.83,2.62,13.976,13.976,0,0,1-2.935,2.864",
    transform: "translate(39.67 109.379)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24810",
    "data-name": "Path 24810",
    d: "M156.686,52.528H158.2a12.315,12.315,0,0,0,3.78-.487,7.6,7.6,0,0,0,5.183-7.489,7.689,7.689,0,0,0-2.463-5.928,9.35,9.35,0,0,0-6.544-2.033h-1.518Zm-3.336,3.207V33.412h4.682a17.54,17.54,0,0,1,5.327.659,9.937,9.937,0,0,1,3.809,2.219,10.639,10.639,0,0,1,3.465,8.262,10.868,10.868,0,0,1-7.389,10.524,17.183,17.183,0,0,1-5.255.63Z",
    transform: "translate(47.31 109.461)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24811",
    "data-name": "Path 24811",
    d: "M169.15,39.313h3.25V40.5a5.971,5.971,0,0,1,1.589-1.274,3.408,3.408,0,0,1,1.675-.387,5.255,5.255,0,0,1,2.678.845l-1.432,2.978a3.107,3.107,0,0,0-1.8-.673c-1.761,0-2.649,1.346-2.649,4.024v7.374h-3.25Z",
    transform: "translate(52.557 111.808)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24812",
    "data-name": "Path 24812",
    d: "M182.105,39.17v8.047c0,2.32.916,3.48,2.764,3.48s2.778-1.16,2.778-3.48V39.17h3.25V47.3a9.236,9.236,0,0,1-.415,2.864,4.983,4.983,0,0,1-1.432,1.976,6.859,6.859,0,0,1-8.391,0,4.926,4.926,0,0,1-1.432-1.976,7.862,7.862,0,0,1-.415-2.864V39.17Z",
    transform: "translate(55.397 111.951)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24813",
    "data-name": "Path 24813",
    d: "M201.894,46.327a4.711,4.711,0,0,0-1.1-3.265,3.666,3.666,0,0,0-2.864-1.26,3.508,3.508,0,0,0-2.864,1.432,5.728,5.728,0,0,0,0,6.315,3.508,3.508,0,0,0,2.864,1.332,3.565,3.565,0,0,0,2.95-1.346,4.8,4.8,0,0,0,1-3.15m3.107,6.687a13.25,13.25,0,0,1-.072,1.761c-.072.515-.1.945-.172,1.332a6.042,6.042,0,0,1-1.432,2.721,6.558,6.558,0,0,1-5.241,2.205,7.016,7.016,0,0,1-4.639-1.518,6.243,6.243,0,0,1-2.176-4.3h3.265a3.8,3.8,0,0,0,.63,1.6A3.494,3.494,0,0,0,198.1,58.2q3.565,0,3.565-4.382V51.768a6.071,6.071,0,0,1-4.467,1.976,6,6,0,0,1-4.639-2.076,7.7,7.7,0,0,1-1.847-5.269,8.119,8.119,0,0,1,1.718-5.226,5.957,5.957,0,0,1,4.883-2.291,5.728,5.728,0,0,1,4.425,2V39.3h3.25Z",
    transform: "translate(58.949 111.825)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24814",
    "data-name": "Path 24814",
    d: "M225.616,47.565l-3.308-7.6-3.465,7.6Zm1.432,3.179H217.44l-2.477,5.413H211.34L222.308,32.43,233,56.157h-3.68Z",
    transform: "translate(64.843 109.04)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24815",
    "data-name": "Path 24815",
    d: "M232.451,39.17v8.047c0,2.32.931,3.48,2.778,3.48s2.778-1.16,2.778-3.48V39.17h3.25V47.3a8.82,8.82,0,0,1-.43,2.864,4.854,4.854,0,0,1-1.432,1.976,6.859,6.859,0,0,1-8.391,0,5.068,5.068,0,0,1-1.432-1.976,8.233,8.233,0,0,1-.4-2.864V39.17Z",
    transform: "translate(70.938 111.951)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24816",
    "data-name": "Path 24816",
    d: "M245.979,43.755V54.78h-3.25V43.755H241.34V40.733h1.389V35.55h3.25v5.183h2.534v3.021Z",
    transform: "translate(75.031 110.388)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24817",
    "data-name": "Path 24817",
    d: "M249.4,31.94h3.25V43.4a5.728,5.728,0,0,1,3.823-1.561,4.926,4.926,0,0,1,3.809,1.647,6.286,6.286,0,0,1,1.217,4.3v8.591h-3.25V48.006a4,4,0,0,0-.6-2.449,2.334,2.334,0,0,0-1.933-.759,2.692,2.692,0,0,0-2.406,1.06,7.159,7.159,0,0,0-.673,3.666v6.844H249.4Z",
    transform: "translate(76.939 108.829)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24818",
    "data-name": "Path 24818",
    d: "M264.683,46.213A4.8,4.8,0,0,0,265.8,49.55a4.009,4.009,0,0,0,3.05,1.231,3.924,3.924,0,0,0,3.05-1.231,5.3,5.3,0,0,0,0-6.544,3.966,3.966,0,0,0-3.05-1.246,3.881,3.881,0,0,0-3.007,1.246,4.51,4.51,0,0,0-1.16,3.207m-3.322,0a6.945,6.945,0,0,1,2.176-5.183,7.661,7.661,0,0,1,10.653,0,7.5,7.5,0,0,1,0,10.582,7.417,7.417,0,0,1-5.384,2.119,7.16,7.16,0,0,1-5.3-2.162,7.274,7.274,0,0,1-2.148-5.355",
    transform: "translate(79.097 111.824)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24819",
    "data-name": "Path 24819",
    d: "M275.61,39.313h3.25V40.5a6.459,6.459,0,0,1,1.589-1.274,3.451,3.451,0,0,1,1.675-.387,5.212,5.212,0,0,1,2.678.845l-1.432,2.978a3.107,3.107,0,0,0-1.8-.673c-1.776,0-2.663,1.346-2.663,4.024v7.374h-3.25Z",
    transform: "translate(82.252 111.809)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24820",
    "data-name": "Path 24820",
    d: "M288.413,55.634h-3.279V41.558h3.25Zm-3.723-19.9a2.1,2.1,0,0,1,2.091-2.091,2.048,2.048,0,0,1,1.5.616,1.99,1.99,0,0,1,.616,1.432,2.048,2.048,0,0,1-.616,1.432,1.973,1.973,0,0,1-2.864,0A2.047,2.047,0,0,1,284.8,35.6",
    transform: "translate(86.174 109.563)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24821",
    "data-name": "Path 24821",
    d: "M295.149,43.755V54.78H291.9V43.755H290.51V40.733H291.9V35.55h3.25v5.183h2.534v3.021Z",
    transform: "translate(88.687 110.388)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24822",
    "data-name": "Path 24822",
    d: "M303.859,50.611,297.53,39.17H301.3l4.31,8.076,4.009-8.076h3.666l-11.2,21.693h-3.709Z",
    transform: "translate(91.719 111.951)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3217",
    "data-name": "Rectangle 3217",
    width: 403.457,
    height: 1.031,
    transform: "translate(0 137.634)",
    fill: "#00b258"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageLogo);
export default __webpack_public_path__ + "static/media/login-page-logo.26128fb0f1ecaa89b6809a411d004513.svg";
export { ForwardRef as ReactComponent };